export enum Statuses {
    Pending,
    Visible,
    Sold,
}